import { AnalyticsArea } from '../analytics-context-types';

/**
 * Every element position `getElementPosition` can report, mapped to the area taxonomy analytics expects.
 * Landscape/vertical inside faces intentionally collapse to the generic "inside": those cards are shown
 * as a whole spread, so the top/bottom half a zone happens to sit in is not a distinct area for the user.
 */
const ANALYTICS_AREA_BY_ELEMENT_POSITION = new Map<string, AnalyticsArea>([
  ['outside-front', 'front'],
  ['outside-back', 'back'],
  ['inside-left', 'inside left'],
  ['inside-right', 'inside right'],
  ['inside', 'inside'],
  ['inside-top', 'inside'],
  ['inside-bottom', 'inside'],
  ['inside-left-top', 'inside'],
  ['inside-left-bottom', 'inside'],
  ['inside-right-top', 'inside'],
  ['inside-right-bottom', 'inside'],
]);

/**
 * Translates an element position into the area reported to analytics.
 *
 * @param elementPosition - The element position reported by `getElementPosition`.
 *
 * @returns The matching analytics area. Positions that are not a known card area fall back to "inside",
 * which is the taxonomy's catch-all for anything that is not the front or a named inside panel.
 */
export const getAnalyticsArea = (elementPosition: string): AnalyticsArea => {
  return ANALYTICS_AREA_BY_ELEMENT_POSITION.get(elementPosition) ?? 'inside';
};
